import { Translation } from '@ps/web-shared-components';
import React from 'react';

import {
  TXTWCL_Deposit_more_in_N0mins,
  TXTWCL_Deposit_more_in_less_than_1min,
  TXTWCL_Deposit_more_in_less_than_N0_d_ELL,
  TXTWCL_Deposit_more_in_less_than_N0_h_ELL
} from './LimitsRecordTimeFrame.messages.json';

interface LimitsRecordTimeFrameProps {
  totalMinutes: number;
}

const LimitsRecordTimeFrame: React.FC<LimitsRecordTimeFrameProps> = ({ totalMinutes }) => {
  if (totalMinutes <= 0) {
    return null;
  }

  if (totalMinutes >= 1440) {
    const days = Math.floor(totalMinutes / 1440);
    return (
      <Translation
        tagName="p"
        {...TXTWCL_Deposit_more_in_less_than_N0_d_ELL}
        values={{ 0: days + 1 }}
      />
    );
  }

  if (totalMinutes >= 60) {
    const hours = Math.floor(totalMinutes / 60);
    return (
      <Translation
        tagName="p"
        {...TXTWCL_Deposit_more_in_less_than_N0_h_ELL}
        values={{ 0: hours + 1 }}
      />
    );
  }

  return totalMinutes > 1 ? (
    <Translation tagName="p" {...TXTWCL_Deposit_more_in_N0mins} values={{ 0: totalMinutes }} />
  ) : (
    <Translation tagName="p" {...TXTWCL_Deposit_more_in_less_than_1min} />
  );
};

export default LimitsRecordTimeFrame;
